import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import template from '../../templates/ProjectScope/ProjectScopeCardNew.rt';
import {AccessRights} from "../../schemas/accessRightsModel";
import * as helpers from '../../utilities/helpers';
import PS from './ProjectScopeActionsNew';
import {toggleFeatureGroupImagePopup} from "../NewScope/newScopeActions";

function mapStateToProps(state, props) {
  const {featureGroup} = props;

  const AR = AccessRights.get(state);

  return {
    visible: featureGroup.visible,
    enabled: featureGroup.enabled,
    clickable: featureGroup.clickable,
    isAccessory: featureGroup.isAccessory,
    canEnableFeaturesGroups: AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin(),
    AR,
    showDelete: AR.isSiteAdmin(true),
    canDelete: AR.isSiteAdmin(true),
    featureGroup
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    updateFeatureGroup: (featureGroup) => dispatch(PS.updateFeatureGroup(featureGroup)),
    toggleFeatureGroupImagePopup: (activeImageEditFeatureGroup) => dispatch(toggleFeatureGroupImagePopup(activeImageEditFeatureGroup))
  };
}

const getInitialImage = (featureGroup) => {
  return featureGroup.customImageUrl;
}


class ProjectScopeCardNew extends PureComponent {
  setInitialState = (props) => {
    this.setState({
      customDisplayName: (!props.featureGroup.customDisplayName
        || !_.isEmpty(props.featureGroup.customDisplayName))
        ? props.featureGroup.groupName : props.featureGroup.customDisplayName,
      customDescription: props.featureGroup.description,
      unitText: props.featureGroup.unitText,
      customImageUrl: getInitialImage(props.featureGroup),
      defaultDisplayName: props.featureGroup.groupName,
      defaultDescription: props.featureGroup.description,
      editingDisplayName: false,
      editingDescription: false,
      acceptIncomingChanges: false
    }, this.forceUpdate);
  }

  isSelectedImage = (image) => {
    let url = helpers.getFeatureGroupIconURL(this.props.featureGroup.groupName, this.props.featureGroup.enabled);
    if (this.state.customImageUrl) {
      url = helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.featureGroup.enabled);
    }
    return _.endsWith(url, `/${image.replace('.svg', '') + '.svg'}`);
  }

  getImageUrl = () => {
    if (this.props.featureGroup.customImageUrl && this.props.newScope) {
      return helpers.getFeatureGroupIconURL(this.props.featureGroup.customImageUrl, this.props.featureGroup.enabled);
    }
    if (this.state.customImageUrl && !this.props.newScope) {
      return helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.featureGroup.enabled);
    }
    return helpers.getFeatureGroupIconURL(this.props.featureGroup.groupName, this.props.featureGroup.enabled);
  };

  updateField = (key, value) => this.props.updateFeatureGroup({...this.props.featureGroup, [key]: value});

  updateFeatureGroup = (updatedFeatureGroup) => {
    this.props.updateFeatureGroup({...updatedFeatureGroup});
  };

  onChangeComplex = (key, value) => {
    if(this.props.newScope) {
      const updatedFeatureGroup = Object.assign({...this.props.featureGroup});
      if(updatedFeatureGroup.isComplex) {
        Object.keys(updatedFeatureGroup.subGroups).forEach(subGroup => {
          updatedFeatureGroup.subGroups[subGroup][key] = value;
          return subGroup
        });
      }
      updatedFeatureGroup[key] = value;
      this.props.updateFeatureGroup(updatedFeatureGroup);
    } else {
      this.updateField(key, value);
    }
  }

  onChangeEnabled = (enabled) => this.onChangeComplex('enabled', enabled);

  onChangeVisible = (visible) => this.onChangeComplex('visible', visible);

  onChangeClickable = (clickable) => this.onChangeComplex('clickable', clickable);

  onChangeAccessory = (isAccessory) => this.onChangeComplex('isAccessory', isAccessory);

  onChangeWizardConfig = (wizardConfigId) => this.onChangeComplex('wizardConfigId', wizardConfigId
    ? null
    : "4cd0d428-a315-4d1f-838a-8d8f340d9288");

  startEdit = (key) => {
    const newState = {
      ["editing" + key]: true
    };

    if (key === "DisplayName" && (!this.state.customDisplayName || !this.state.customDisplayName.length)) {
      newState.customDisplayName = this.props.featureGroup.name;
    } else if (key === "Description" && (!this.state.customDescription || !this.state.customDescription.length)) {
      newState.customDescription = this.props.featureGroup.description;
    }

    this.setState(newState, () => {
      let el = this["input" + key];
      if (el && el.focus) {
        el.focus();
        el.selectionStart = el.selectionEnd = el.value.length;
      }
    });
  };

  editImageClick = () => {
    if (this.props.newScope) {
      // console.log("this.props.featureGroup", this.props.featureGroup);
      this.props.toggleFeatureGroupImagePopup(this.props.featureGroup)
    } else {
      this.startEdit('ImageUrl')
    }
  };

  stopEdit = (key, value) => {
    this.setState({["editing" + key]: false, ["custom" + key]: value});
    let field = "";
    switch (key) {
      case "ImageUrl":
        field = "customImageUrl";
        break;
      case "DisplayName":
        field = "customDisplayName";
        break;
      case "Description":
        field = "customDescription";
        break;
      case "unitText":
        field = "unitText";
        break;
    }
    if (this.props.newScope) {
      const updatedFeatureGroup = this.props.featureGroup;
      updatedFeatureGroup[field] = value;
      this.updateFeatureGroup(updatedFeatureGroup);
    } else {
      this.updateField(field, value);
    }
  };

  setAcceptIncomingChanges = () => this.setState({acceptIncomingChanges: true});

  componentWillMount() {
    this.setInitialState(this.props);
  }

  componentDidMount() {
    document.addEventListener("newFeatureGroupAdded", this.setAcceptIncomingChanges);
  }

  componentWillUnmount() {
    document.removeEventListener("newFeatureGroupAdded", this.setAcceptIncomingChanges);
  }

  componentDidUpdate(props) {
    if (this.state.acceptIncomingChanges) {
      this.setInitialState(props);
    }
  }

  handleDelete(featureGroup) {
    console.log("TODO: add feature group delete logic", featureGroup);
  }

  removeFeatureGroupFromCategory = () => {
    this.props.removeFeatureGroupFromCategory(this.props.featureGroup);
  }

  render = template
}

ProjectScopeCardNew.propTypes = {
  featureGroup: PropTypes.object.isRequired,
  activeQtCategoryIndex: PropTypes.number,
  removeFeatureGroupFromCategory: PropTypes.func,
  getFeatureCreatorLink: PropTypes.func,
  isUnsaved: PropTypes.bool,
  newScope: PropTypes.bool
};

const ProjectScopeCard = connect(mapStateToProps, mapDispatchToProps)(ProjectScopeCardNew);

export default ProjectScopeCard;
